import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.base.c0};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 22px;
  cursor: not-allowed;
`
